export default "__VITE_ASSET__5$2kIwQu__"